import { object } from "@/common/object.util";
import ApiAdmin from "@/services/apiAdmin.service";

import { FETCH_ALL, SAVE } from "@/store/actions/actions.type";

import {
  FETCH_ALL_START,
  SET_ALL,
  FETCH_ALL_END,
  SET,
  SAVE_START,
  SAVE_END
} from "@/store/mutations/mutations.type";

const defaults = Object.freeze({
  niveisAcesso: {}
  // userId: "23932909093dfffdff",
  // userName: "teste",
  // administrativo: {
  //   gerenciarUsuarios: {
  //     nome: "Gerenciar Usuarios",
  //     valor: true,
  //     descricao: "Permite o gerenciamento dos usuários no sistema",
  //     originalRoleRepresentation: []
  //   },
  //   criarChamados: {
  //     nome: "Realizar chamados",
  //     valor: true,
  //     descricao: "	Permite criação de chamados",
  //     originalRoleRepresentation: []
  //   }
  // },
  // financeiro: {
  //   verBoletos: {
  //     nome: "Ver boletos",
  //     valor: true,
  //     descricao: "Permite que gere boletos",
  //     originalRoleRepresentation: []
  //   },
  //   verRelatorios: {
  //     nome: "Ver relatórios",
  //     valor: true,
  //     descricao: "Permite a geração de Relatórios",
  //     originalRoleRepresentation: []
  //   },
  //   verPlanos: {
  //     nome: "Ver planos",
  //     valor: true,
  //     descricao: "Permite a gestão de planos",
  //     originalRoleRepresentation: []
  //   },
  //   pedirCancelamento: {
  //     nome: "Pedir cancelamento",
  //     valor: true,
  //     descricao: "nnnnnnn",
  //     originalRoleRepresentation: []
  //   }
});

const state = {
  niveisAcesso: object.clone(defaults.niveisAcesso),
  isFetchingNiveisAcesso: false,
  isFetchingUsuarios: false,
  isSavingNiveisAcesso: false,
  isDeletingNiveisAcesso: false,
  deletingId: null
};
const getters = {
  niveisAcesso(state) {
    return state.niveisAcesso;
  },
  usuarios(state) {
    return state.usuarios;
  },
  isFetchingNiveisAcesso(state) {
    return state.isFetchingNiveisAcesso;
  },
  isFetchingUsuarios(state) {
    return state.isFetchingUsuarios;
  },
  isSavingNiveisAcesso(state) {
    return state.isSavingNiveisAcesso;
  },
  isDeletingNiveisAcesso(state) {
    return state.isDeletingNiveisAcesso;
  },
  deletingId(state) {
    return state.deletingId;
  }
};

const actions = {
  [FETCH_ALL](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_ALL_START);
      ApiAdmin.query(`keycloak/roles/list/${params.id}/${params.nome}`, params)
        .then(response => {
          context.commit(SET_ALL, response.data);
          resolve();
        })
        .catch(e => {
          reject(e.response.data);
        })
        .finally(() => {
          context.commit(FETCH_ALL_END);
        });
    });
  },
  [SAVE](context, params) {
    console.log(params);

    return new Promise((resolve, reject) => {
      context.commit(SAVE_START);
      ApiAdmin.post("keycloak/roles/manage/", { payload: params })
        .then(response => {
          resolve(response);
        })
        .catch(e => {
          reject(e);
        })
        .finally(() => {
          context.commit(SAVE_END);
        });
    });
  }
};

const mutations = {
  [FETCH_ALL_START](state) {
    state.isFetchingNiveisAcesso = true;
  },
  [SET_ALL](state, niveisAcesso) {
    state.niveisAcesso.data = niveisAcesso;
  },
  [FETCH_ALL_END](state) {
    state.isFetchingNiveisAcesso = false;
  },
  [SAVE_START](state) {
    state.isSavingNiveisAcesso = true;
  },
  [SET](state, niveisAcesso) {
    state.niveisAcesso = niveisAcesso;
  },
  [SAVE_END](state) {
    state.isSavingNiveisAcesso = false;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
